import React from "react";
import logo from "../assets/guardify-logo-dark.svg"; // Adjust path if needed

export default function AuthHeader({ limitedSupport }) {
  return (
    <div className="auth-header">
      <img src={logo} className="logo" alt="Guardify" />
      <p>Safe, simple, and secure digital evidence management</p>
      {limitedSupport && (
        <div>
          <p style={{ color: "red" }}>Your browser is not fully supported.</p>
          <a
            href="https://guardify.helpscoutdocs.com/article/714-system-requirements"
            target="_blank"
            rel="noopener noreferrer"
          >
            Guardify System Requirements
          </a>
        </div>
      )}
    </div>
  );
} 